import { Branding, DisabledPrompt, NavLink, useModel, useRoute, BrandingStyle,BrandingDisabledIf } from "bcms-react";
import CustomAccordion, { CustomAccordionContent, CustomAccordionToggle, useCustomAccordion } from "components/custom-ui/CustomAccordion";
import React, { useEffect, useState } from "react";
import { SVGAsset } from "res";
import Util from 'classes/Util';
import "./styles.css";
import BID126UtilityNavMenuItems from "./customUtilityNavItems/BID126UtilityNavMenuItems";
import BID932UtilityNavMenuItems from "./customUtilityNavItems/BID932UtilityNavMenuItems";
import BID2132PUtilityNavMenuItems from "./customUtilityNavItems/BID2132PUtilityNavMenuItems";
import BID2132BUtilityNavMenuItems from "./customUtilityNavItems/BID2132BUtilityNavMenuItems";
import BID1225BUtilityNavMenuItems from "./customUtilityNavItems/BID1225BUtilityNavMenuItems";
import BID1225PUtilityNavMenuItems from "./customUtilityNavItems/BID1225PUtilityNavMenuItems";

const UtilityNavItemContext = React.createContext(null);

export default function UtilityNavView(props) {
    const { user, branding } = useModel();
    const bid = branding.options.bid_abi22;

    const chatLink = () =>{
        if(Util.inMabi) {
           Util.openMabiChat()
          }
          else {
            window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/chat", "_blank")
          }
      
        };
        
    const navigate = useRoute();

    const onMailItemClick = () => {
        const url = window.location.href.slice(0, window.location.href.indexOf("#")) + "#/secureMail";
        window.open(url, "_blank");
    }

    let alertsItem = <BrandingDisabledIf id="notifi_version_abi22"  exp={(val) => val !== "Disabled" }>               
        <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" && val !== "1588"} >   
            <Branding id="alerts_abi22" value="true">                         
                    <UtilityNavMenuItem label="Alerts" route="/notifications" data-point="Utility_Alerts" />
            </Branding>  
        </Branding>     
        <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" || val == "1588"} >   
            <Branding id="alerts_abi22" value="true">                         
                    <UtilityNavMenuItem label="Advanced Alerts" route="/notifications" data-point="Utility_Alerts" />
            </Branding>  
        </Branding>   
    </BrandingDisabledIf>;

    // Remove alerts if "1224" is set. Alerts are shown in the main nav for that bid.
    alertsItem = branding.options.bid_abi22 === "1224" ? undefined : alertsItem;

    // NOTE: Variable "showUtilityNavMenu" was added in order to completely customize the items in this nav.
    // Some bids have different items in different orders with different names, 
    // so components like "BID126UtilityNavItems" were created to account for that variance.
    const showUtilityNavMenu = bid !== "126" && bid !== "932" && bid !== "2132P" && bid !== "2132B" && bid !== "1225B" && bid !== "1225P";

    const showDefaultUtilityNavMenu = bid !== "2132P" && bid !== "2132B" && bid !== "1225B" && bid !== "1225P";
    const show2132PUtilityNavMenu = bid === "2132P";
    const show2132BUtilityNavMenu = bid === "2132B";
    const show1225BUtilityNavMenu = bid === "1225B";
    const show1225PUtilityNavMenu = bid === "1225P";

    return (
        <UtilityNavContainer>
            <UtilityNavBadge initials={ user.initials } />

            <UtilityNavItemContainer>
                <UtilityNavItem label={ `${ user.first } ${ user.last }` } data-point="Utility_User">
                    
                    {/* bid 126 will use different items than what is declared below. */}
                    <BID126UtilityNavMenuItems/>
                    <BID932UtilityNavMenuItems/>
                    <BID2132PUtilityNavMenuItems />
                    <BID2132BUtilityNavMenuItems />
                    <BID1225BUtilityNavMenuItems />
                    <BID1225PUtilityNavMenuItems />

                    {/* The nav items below will only be shown if bid 126 is not set. */}
                    { showUtilityNavMenu && 
                    <UtilityNavMenu icon="CircleProfileIcon" label="Profile" data-point="Utility_Profile">
                        <BrandingStyle style={{"backgroundColor" : "utility_subnav_bg_abi22"}} className="flex-container flex-vertical" >
                            <Branding id="email_abi22" value="true">
                                <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" && val !== "1588"} >
                                    <UtilityNavMenuItem label="Email Address" route="/email" data-point="Utility_Email" />
                                </Branding>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1702" && val !== "1224" } >
                            <DisabledPrompt>
                                <Branding id="tax_documents_abi22" value="true" default="false">
                                    <UtilityNavMenuItem label="Tax Documents" route="/taxDocuments" data-point="Utility_Tax_Documents" />
                                </Branding>
                            </DisabledPrompt>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" ||val == "1588"  } >
                            <UtilityNavMenuItem label="Email" route="/email" data-point="Utility_Email" />
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val === "1224" } >
                                <UtilityNavMenuItem label="Phone Number" route="/phoneNumber" data-point="Utility_Phone" />
                            </Branding>
                            <Branding id="phone_abi22" value="true">
                                <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" && val !== "1224" } >
                                    <UtilityNavMenuItem label="Phone" route="/phoneNumber" data-point="Utility_Phone" />
                                </Branding>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" } >
                            <DisabledPrompt>
                                <UtilityNavMenuItem label="Phone Numbers" route="/phone" data-point="Utility_Phone" />
                            </DisabledPrompt>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1588" && val !== "1224" } >
                                <Branding id="address_abi22" value="true" default="true" >    
                                    <DisabledPrompt>
                                        <UtilityNavMenuItem label="Address" route="/address" data-point="Utility_Address" />
                                    </DisabledPrompt>
                                </Branding>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val === "1224" } >
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Address" route="/address" data-point="Utility_Address" />
                                </DisabledPrompt>
                            </Branding>
                            <UtilityNavMenuItem label="Password" route="/password" data-point="Utility_Password" />  
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" } >
                            <Branding id="user_id_abi22" value="true">
                                <UtilityNavMenuItem label="User ID" route="/userId" data-point="Utility_User_ID"/>      
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val === "1224" }>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Unauthorized Devices" data-point="Utility_Unauthorized_Debit_Card_Dispute" />
                                </DisabledPrompt>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1224" } >
                                <UtilityNavMenuItem label="Stopped Numbers" route="/stoppedNumbers" data-point="Utility_Stopped_Numbers" />
                            </Branding>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" } >
                            <DisabledPrompt>
                                <UtilityNavMenuItem label="Stopped Numbers" route="/stoppedNumbers" data-point="Utility_Stopped_Numbers" />
                            </DisabledPrompt>
                            <Branding id="user_id_abi22" value="true">
                                <UtilityNavMenuItem label="User ID" route="/userId" data-point="Utility_User_ID" />      
                            </Branding>                       
                            </Branding> 
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val == "1702" } >
                            <DisabledPrompt>
                                <Branding id="tax_documents_abi22" value="true" default="false">
                                    <UtilityNavMenuItem label="Tax Documents" route="/taxDocuments" data-point="Utility_Tax_Documents" />
                                </Branding>
                            </DisabledPrompt>
                            </Branding>                           
                            {/**<DisabledPrompt>
                                <UtilityNavMenuItem label="Contact Information" route="/contactinformation" data-point="Utility_Contact_Information" />
                            </DisabledPrompt> */}
                        </BrandingStyle>
                    </UtilityNavMenu>
                    }

                    {/* The nav items below will only be shown if bid 126 is not set. */}
                    { showUtilityNavMenu && 
                    <UtilityNavMenu icon="GearIcon" label="Settings" data-point="Utility_Settings">
                        <BrandingStyle style={{"backgroundColor" : "utility_subnav_bg_abi22"}} className="flex-container flex-vertical" >
                            
                            { alertsItem }          

                            <UtilityNavMenuItem label="Authorized Devices" route="/authorizedDevicesWorkflow" data-point="Utility_Authorized_Devices" />

                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "123" && val !== "1224" } >   
                                <Branding id="instant_balances_abi22" value="true">
                                    <UtilityNavMenuItem label="Fast Balances" route="/settingsFastBalancesWorkflow" data-point="Utility_Instance_Balances" />
                                </Branding>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val === "1224" } >   
                                <UtilityNavMenuItem label="Fast Balances" route="/settingsFastBalancesWorkflow" data-point="Utility_Instance_Balances" />
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val == "123" } >   
                                <Branding id="instant_balances_abi22" value="true">
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Instant Balances" route="disabled" data-point="Utility_Instance_Balances" />
                                </DisabledPrompt>
                            </Branding>
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1224" }>
                                <Branding id="text_banking_abi22" value="true">
                                    <UtilityNavMenuItem label="Text Banking" data-point="Utility_Text_Banking">
                                        <BrandingStyle style={{"backgroundColor" : "utility_subnav_bg_abi22"}} className="flex-container flex-vertical" >
                                            <UtilityNavMenuItem label="Mobile Nicknames" route="/mobileNicknamesWorkflow" />
                                            <UtilityNavMenuItem label="Text Banking Phone List" route="/textBanking" />
                                            <UtilityNavMenuItem label="Register Phone Number" route="/textBanking" />
                                        </BrandingStyle>
                                    </UtilityNavMenuItem>
                                </Branding>
                            </Branding>
                            
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1224" }>
                                <Branding id="authorized_apps_abi22" value="true">
                                    <UtilityNavMenuItem label="Authorized Apps" route="/authorizedApps" data-point="Utility_Authorized_Apps" />
                                </Branding>   
                            </Branding>
                            <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "1224" }>
                                <Branding id="secure_forms_abi22" value="true" default="true">
                                    <UtilityNavMenuItem label="Secure Forms" route="/secureForms" data-point="Utility_Secure_Forms" />
                                </Branding>   
                            </Branding>
                            <Branding id="bid_abi22" value="Standard">
                                <Branding id="users_abi22" value="true">
                                    <UtilityNavMenuItem label="Users" route="/addUserWorkflow" data-point="Utility_Users" />
                                </Branding>
                            </Branding>
                            <UtilityNavMenuItem label="User Activity" route="/userActivityWorkflow" data-point="Utility_User_Activity" />
                            <UtilityNavMenuItem label="Accepted Disclosures" route="/acceptedDisclosuresWorkflow" data-point="Utility_Accepted_Disclosures" />
                            <Branding id="delete_an_account_abi22" value="true" default="true">
                            <DisabledPrompt>
                                <UtilityNavMenuItem label="Delete An Account" route="/deleteanaccount" data-point="Utility_Delete_Account" />
                            </DisabledPrompt>
                            </Branding>
                        </BrandingStyle>
                    </UtilityNavMenu>
                    }

                    {/* The nav items below will only be shown if bid 126 is not set. */}
                    { showUtilityNavMenu && 
                    <Branding id="bid_abi22" value="Standard" exp={(val) => val === "1224" } >  
                        <UtilityNavMenu icon="HeadsetIcon" label="Additional Services" data-point="Utility_Settings">
                            <BrandingStyle style={{"backgroundColor" : "utility_subnav_bg_abi22"}} className="flex-container flex-vertical" >
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Lending Solutions" data-point="Utility_Lending_Solutions" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Unauthorized Debit Card Dispute" data-point="Utility_Unauthorized_Debit_Card_Dispute" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Monthly Interest Transfer Form" data-point="Utility_Monthly_Interest_Transfer_Form" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Today at Manasquan" data-point="Utility_Today_At_Manasquan" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Schedule An Appointment" data-point="Utility_Schedule_An_Appointment" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Save Your Change" data-point="Utility_Save_Your_Change" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Branch Locations" data-point="Utility_Branch_Locations" />
                                </DisabledPrompt>
                                <DisabledPrompt>
                                    <UtilityNavMenuItem label="Contact Us" data-point="Utility_Contact_Us" />
                                </DisabledPrompt>
                            </BrandingStyle>
                        </UtilityNavMenu>
                    </Branding>
                    }
                    
                    {/* messages link */}
                    {/* The nav items below will only be shown if bid 126 is not set. */}
                    { showUtilityNavMenu && 
                    <>
                        <Branding id="messages_abi22" value="true" default="true">
                            <div className="utility-nav-menu-header messages-link flex-container flex-horizontal align-top clickable" onClick={() => {navigate("/messages/")}} data-point="Utility_Messages">
                                <div className="set-width flex-container flex-horizontal align-center">
                                    <SVGAsset id="EnvelopeIcon" />
                                </div>
                                <div className="flex-width">
                                    <span>Messages</span>
                                </div>
                                <div className="set-width text-center alert-bubble">
                                    <span>3</span>
                                </div>
                            </div>
                        </Branding>
                        <Branding id="secure_mail_abi22" value="true" default="true">
                            <div className="utility-nav-menu-header mail-link flex-container flex-horizontal align-top clickable" onClick={ onMailItemClick } data-point="Utility_Mail">
                                <div className="set-width flex-container flex-horizontal align-center">
                                    <SVGAsset id="EnvelopeIcon" />
                                </div>
                                <div className="flex-width">
                                    <span>Mail</span>
                                </div>
                            </div>
                        </Branding>
                    </>
                    }
                </UtilityNavItem>
                
               {/* The nav items below will only be shown if bid 2132P and 2132B is not set. */}
               {showDefaultUtilityNavMenu  && 
               <>
                    <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "932" }>
                        <Branding id="help_abi22" value="true">
                            <DisabledPrompt><UtilityNavItem label="Help" data-point="Utility_Help" /></DisabledPrompt>               
                        </Branding> 
                    </Branding>
                    <Branding id="bid_abi22" value="Standard">
                        <DisabledPrompt><UtilityNavItem label="Print"  data-point="Utility_Print" /></DisabledPrompt>
                    </Branding>
                    <Branding id="bid_abi22" value="Standard" exp={(val) => val !== "932" }>
                        <Branding id="secure_mail_abi22" value="true">       
                            <UtilityNavItem label="Mail" onClick={ onMailItemClick } data-point="Utility_Mail" />
                        </Branding> 
                    </Branding>   
                    <Branding id="chat_abi22" value="true">       
                        <UtilityNavItem label="Chat" onClick={ chatLink } data-point="Utility_Chat" />
                    </Branding> 
                    
                    <UtilityNavItem label="Log Out" route="/login" data-point="Utility_LogOut" />
                </>
               }

               { show2132PUtilityNavMenu && 
               <>
                <DisabledPrompt><UtilityNavItem label="Help" data-point="Utility_Help" /></DisabledPrompt>
                <UtilityNavItem label="Chat" onClick={chatLink} data-point="Utility_Chat" />
                <DisabledPrompt><UtilityNavItem label="Print" data-point="Utility_Print" /></DisabledPrompt>
                <DisabledPrompt><UtilityNavItem label="Schedule an Appointment" data-point="Utility_Schedule_an_Appointment" /></DisabledPrompt>
                <UtilityNavItem label="Log Out" route="/login" data-point="Utility_LogOut" />
               </>
               }

               {show2132BUtilityNavMenu && 
               <>
                <UtilityNavItem label="Chat" onClick={chatLink} data-point="Utility_Chat" />
                <DisabledPrompt><UtilityNavItem label="Print" data-point="Utility_Print" /></DisabledPrompt>
                <DisabledPrompt><UtilityNavItem label="Schedule an Appointment" data-point="Utility_Schedule_an_Appointment" /></DisabledPrompt>
                <UtilityNavItem label="Log Out" route="/login" data-point="Utility_LogOut" />
               </>
               }
                {show1225BUtilityNavMenu &&
                <>
                <DisabledPrompt><UtilityNavItem label="Help" data-point="Utility_Help" /></DisabledPrompt>
                <DisabledPrompt><UtilityNavItem label="Print" data-point="Utility_Print" /></DisabledPrompt>
                <UtilityNavItem label="Chat" onClick={chatLink} data-point="Utility_Chat" />
                <UtilityNavItem label="Log Out" route="/login" data-point="Utility_LogOut" />
                </>
                }
                {show1225PUtilityNavMenu &&
                <>
                <DisabledPrompt><UtilityNavItem label="Help" data-point="Utility_Help" /></DisabledPrompt>
                <DisabledPrompt><UtilityNavItem label="Print" data-point="Utility_Print" /></DisabledPrompt>
                <UtilityNavItem label="Chat" onClick={chatLink} data-point="Utility_Chat" />
                <UtilityNavItem label="Log Out" route="/login" data-point="Utility_LogOut" />
                </>
                }
            </UtilityNavItemContainer>
        </UtilityNavContainer>
    );
}

export const useUtilityNavItemContext = () => React.useContext(UtilityNavItemContext);

/**
 * @name UtilityNavContainer
 * @function
 * @extends React.Component
 * @exported true
 * @description Main container for the Utility Nav
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      ...
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavContainer(props) {
    return (
        <div className="utility-nav-container set-width flex-container flex-horizontal align-center">
            { props.children }
        </div>
    );
}

/**
 * @name UtilityNavBadge
 * @function
 * @param {STRING} initials - The initials that should be shown
 * @extends React.Component
 * @exported true
 * @description The Badge that is shown in the Utility Nav
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      ...
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavBadge(props) {
    return (
        <BrandingStyle
            style={{ "backgroundColor": "nav_badge_bg_abi22", }}
            className="utility-nav-badge set-width text-center flex-container align-center">
            <div>
                <BrandingStyle style={{ "color": "nav_badge_text_abi22", }}>{props.initials ?? "[ABC]"}</BrandingStyle>
            </div>
        </BrandingStyle>
    );
}

/**
 * @name UtilityNavItemContainer
 * @function
 * @extends React.Component
 * @exported true
 * @description The container that wraps all UtilityNavItems
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        ...
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavItemContainer(props) {
    return (
        <div className="utility-nav-item-container flex-width flex-container flex-horizontal">
            { props.children }
        </div>
    );
}

/**
 * @name UtilityNavItem
 * @function
 * @param {STRING} label - The label that should be shown for the nav item
 * @param {STRING} route - The route that the nav item should go to on click
 * @param {STRING} data-point - The data point that should be added to the UtilityNavItem
 * @extends React.Component
 * @exported true
 * @description The nav item used in the UtilityNavItemContainer
 * @notes </br>
 * - If the nav item has children, the item will be switched to an accordion
 * - If the nav item has children, on click it would not route but open the accordion
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        <UtilityNavItem label="First Item">
 *          ...
 *        </UtilityNavItem>
 * 
 *        <UtilityNavItem label="Second Item" route="/place" />
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavItem(props) {
    const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

    const [ state, setState ] = useState("");
    const label = props.label ?? "[username]";

    const onClick = () => {
        setState("");

        if(props.onClick instanceof Function) {
            props.onClick();
        }
    }

    return (
        <UtilityNavItemContext.Provider value={{ "state" : state, set: setState }}>

          <div className="utility-nav-item flex-width" data-point={ point }>
            {
                React.Children.count(props.children) > 0
                    ?   <CustomAccordion className="utility-nav-item-accordion">
                            <CustomAccordionToggle>
                                <BrandingStyle style={{ 
                                                "color" : "utility_nav_text_abi22"
                                                }} element={
                                                <p onClick={ onClick }>
                                                    { label }
                                                    <BrandingStyle style={{ 
                                                                    "fill": "utility_nav_text_abi22"
                                                                    }} element={<SVGAsset id="DownChevronIcon" />} />
                                                </p>} />
                            </CustomAccordionToggle>

                            <CustomAccordionContent>
                                { props.children }
                            </CustomAccordionContent>
                        </CustomAccordion>
                    
                    : <NavLink to={ props.route } onClick={ onClick }>
                        <BrandingStyle style={{
                            "color" : "utility_nav_text_abi22"
                        }}  element={ <span>{ label }</span> } /> 
                      </NavLink>
                    
            }
          </div>
        </UtilityNavItemContext.Provider>
    );
}

/**
 * @name UtilityNavMenu
 * @function
 * @param {STRING} icon - The icon that should be shown in the header
 * @param {STRING} label - The label that should be shown in the header
 * @param {STRING} data-point - The data point that should be added to the UtilityNavMenu
 * @extends React.Component
 * @exported true
 * @description A sub accordion within the UtilityNavItem
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        <UtilityNavItem label="First Item">
 *          <UtilityNavMenu icon="DownChevronIcon" label="Profile">
 *            <UtilityNavMenuItem />
 *          </UtilityNavMenu>
 *        </UtilityNavItem>
 * 
 *        <UtilityNavItem label="Second Item" route="/place" />
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavMenu(props) {
    const point =props["data-point"] ?props["data-point"] : props.dataPoint ?? "";

    return (
        <CustomAccordion data-point={ point }>
            <UtilityNavMenuHeader data-point={ point } icon={ props.icon } label={ props.label } />

            <CustomAccordionContent className="flex-container flex-vertical">
                { props.children }
            </CustomAccordionContent>
        </CustomAccordion>
    );
}

/**
 * @name UtilityNavMenuHeader
 * @function
 * @param {STRING} icon - The icon that should be shown
 * @param {STRING} label - The label that should be set
 * @exported true
 * @extends React.Component
 * @description The header item used in the UtilityNavMenu
 * @notes
 * - This is apart of the UtilityNavMenu, this should not need implemented anywhere else
 */
export function UtilityNavMenuHeader(props) {
    const { open, close } = useCustomAccordion();
    const { set, state } = useUtilityNavItemContext();

    const isOpen = state === props.label;
    const onClick = () => set(isOpen ? "" : props.label);
    const setAccordion = () => isOpen ? open() : close();
    const dataPointLabel = props["data-point"] ? { "data-point" : `${ props["data-point"] }_Label` } : {};
    const dataPointChevronIcon = props["data-point"] ? { "data-point" : `${ props["data-point"] }_Chevron_Icon` } : {};

    useEffect(() => setAccordion(), [ state ]);

    return (
        <div className={ `utility-nav-menu-header flex-container flex-horizontal align-top clickable ${ isOpen && "open" }` } onClick={ onClick }>
            <div className="set-width flex-container flex-horizontal align-center">
                <SVGAsset id={ props.icon } />
            </div>
            <div className="flex-width">
                <span { ...dataPointLabel }>{ props.label }</span>
            </div>
            <div className="set-width text-right">
                <SVGAsset id={ isOpen ? "UpChevronIcon" : "DownChevronIcon" } { ...dataPointChevronIcon } />
            </div>
        </div>
    );
}

/**
 * @name UtilityNavMenuItem
 * @function
 * @param {STRING} label - The label to be shown for the menu item
 * @param {STRING} route - The route that the link should go to on click
 * @param {STRING} data-point - The data point that should be added to the UtilityNavMenuItem
 * @extends React.Component
 * @exported true
 * @description The menu item for the UtilityNavMenu
 * @notes
 * - If children exist, the menu item will be a toggable accordion
 * - If children exist, the route will be overwritten and not route
 * @example
 * export default function Component(props) {
 *  return (
 *    <UtilityNavContainer>
 *      <UtilityNavBadge initials="AB" />
 *      
 *      <UtilityNavItemContainer>
 *        <UtilityNavItem label="First Item">
 *          <UtilityNavMenu icon="DownChevronIcon" label="Profile">
 *            <UtilityNavMenuItem label="Item" route="/item" />
 * 
 *            <UtilityNavMenuItem>
 *              <UtilityNavMenuItem label="" route="" />
 *            </UtilityNavMenuItem>
 *          </UtilityNavMenu>
 *        </UtilityNavItem>
 * 
 *        <UtilityNavItem label="Second Item" route="/place" />
 *      </UtilityNavItemContainer>
 *    </UtilityNavContainer>
 *  );
 * }
 */
export function UtilityNavMenuItem(props) {
    const label = props.label ?? "[UtilityMenuLink]";
    const point = props["data-point"] ?props["data-point"] : props.dataPoint ?? "";
    const hasChildren = React.Children.count(props.children) > 0;

    return (
        <>
            {
                hasChildren
                    ?   <div className="utility-nav-menu-item clickable utility-nav-menu-accordion" data-point={ point }>
                            <CustomAccordion className="menu-nav-item-accordion" activeClass="sub-nav-open">
                                <CustomAccordionToggle>
                                    <UtilityNavMenuItemHeader label={ label } />
                                </CustomAccordionToggle>

                                <CustomAccordionContent className="flex-container flex-vertical">
                                    { props.children }
                                </CustomAccordionContent>
                            </CustomAccordion>
                        </div>
                    
                    :   <NavLink className="utility-nav-menu-item clickable" to={ props.route } dataPoint={ point }>
                            { props.label }
                        </NavLink>
            }
        </>
    );
}

/**
 * @name UtilityNavMenuItemHeader
 * @function
 * @param {STRING} label - The label to be shown for the menu item
 * @param {BOOLEAN} useMainNavUI - A boolean that adds main nav ui (css) to the accordion. Only used for the main
 * nav since the functionality is the same but the ui is slightly different.
 * @extends React.Component
 * @exported true
 * @notes This should not be used besides in the UtilityNavMenuItem
 * @description Header component for the UtilityNavMenuItem so we can access accordion state
 */
export function UtilityNavMenuItemHeader(props) {
    const { state } = useCustomAccordion();
    const useMainNavUI = props.useMainNavUI ?? false;
    const className = props.className ?? "";

    return (
        <div className={"flex-container flex-horizontal align-center " + className}>
            <div className="flex-width">{ props.label }</div>
            <div className="set-width chevron-container text-right">
                { !useMainNavUI && <SVGAsset id={ state ? "UpChevronIcon" : "DownChevronIcon" } /> }
                { useMainNavUI && <SVGAsset id={ "RightChevronIcon" } /> }
            </div>
        </div>
    );
}